import React from 'react'

import Component from './Component'
import Form from './Form/ImageCardsBlockForm'
import { defaultSettings } from './defaults/settings'
import { createDefaultCard, DEFAULT_CARD_COUNT } from './constants'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <Component {...props} {...mergedSettings} />,

        name: 'benchmarx/content/image-cards-block',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            cards: Array.from({ length: DEFAULT_CARD_COUNT }, createDefaultCard),
            selectedCardIndex: null,
        }),
    }
}

export default createPlugin
